<template>
  <div class="pinwall__upload">
    <section>
      <FileInput
        :id="id"
        ref="fileInput"
        @fileUploading="fileUploading = true"
        @fileUploaded="uploaded"
      />

      <button
        :disabled="!image"
        :loading="fileUploading"
        type="submit"
        @click="validateBeforeSubmit"
        :class="
          fileUploading
            ? 'button is-success is-rounded action-button is-loading'
            : 'button is-success is-rounded action-button'
        "
      >
        {{ $t("save.name") }}
      </button>
    </section>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { generateId } from "../../utils/helpers";
import FileInput from "./FileInput";

export default {
  name: "add",
  props: {
    pinwallId: {
      type: String
    },
    password: {
      type: String
    }
  },
  data() {
    return {
      id: generateId(),
      name: "",
      multiUpload: false,
      video: null,
      image: null,
      proportion: 0,
      pendingFiles: 0,
      fileUploading: false
    };
  },
  components: {
    FileInput
  },
  methods: {
    ...mapActions(["createPost"]),
    uploaded(files) {
      this.fileUploading = false;
      this.image = files.image;
      this.video = files.video;
      this.audio = files.audio;
      this.proportion = files.proportion;
      this.pendingFiles = files.pendingFiles;
      this.addFromSearch = false;
      if (this.pendingFiles > 0 || this.multiUpload) {
        this.multiUpload = true;
        this.create();
      }
    },
    create() {
      this.createPost({
        id: this.id,
        image: this.image,
        pinwallId: this.pinwallId,
        password: this.password,
        video: this.video,
        audio: this.audio,
        proportion: this.proportion,
        view: ""
      }).then(data => {
        var emitModel = {
          postList: data,
          view: "",
          windowWidth: this.windowWidth,
          sort: "presentation"
        };
        this.$socket.emit(
          process.env.VUE_APP_SOCKET_ON,
          this.pinwallId + (this.password || ""),
          emitModel
        );
        this.id = generateId();
        if (this.pendingFiles > 0) {
          this.$refs.fileInput.uploadNextFile();
        } else {
          window.location.reload();
        }
      });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$buefy.toast.open({
            message: "Post is valid!",
            type: "is-success",
            position: "is-top-right"
          });
          this.create();
          return;
        }
        this.$buefy.toast.open({
          message: "Post is not valid! Please check the fields.",
          type: "is-danger",
          position: "is-top-right"
        });
      });
    }
  }
};
</script>
